module.exports = __webpack_public_path__ + "static/media/Cross-red.b5be9e39.svg";